import { Component } from "react";
import { connect } from "react-redux";
import ViewList from "@mui/icons-material/ViewList";
import Today from "@mui/icons-material/Today";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Button from "@mui/material/Button";
import { dispatchWarning } from "../redux/parameter/parameterActions";
import { loadActiveUser } from "../redux/users/usersActions";
import { validateDaySendData } from "../redux/day/dayEditionActions";

class OptionChoicesActivity extends Component {
    constructor(props) {
        super(props);
        this.state = {
            current_day: null,
            dayValidationAuthorized: false,
            validatedDay: false,
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        let modifiedState = prevState;

        if (nextProps.current_day !== undefined && nextProps.current_day !== false) {
            modifiedState.current_day = nextProps.current_day;
        }

        if (
            (nextProps.current_day && !prevState.currentDay) ||
            (prevState.currentDay && prevState.dayValidated) ||
            (nextProps.current_day &&
                prevState.current_day &&
                nextProps.current_day.validation !== prevState.current_day.validation)
        ) {
            modifiedState.dayValidated = nextProps.current_day.validation;
        }

        return modifiedState;
    }

    render() {
        return (
            <div className="sub-header">
                <div className="row">
                    <div className="col-lg-5 col-md-5 col-sm-5 col-5 without-side-padding">
                        {/* <FormControlLabel
							label="GPS"
							classes={{ label: "white-text" }}
							id="GPS_button"
							control={
								<Switch
									onChange={this.props.changeGPS}
									checked={!this.props.gpsStopped}
									value={"gps"}
									color="secondary"
								/>
							}
						/> */}
                    </div>
                    <div
                        className={
                            "col-lg-5 col-md-5 col-sm-5 col-5 without-side-padding" +
                            (this.props.current_day !== null && this.props.current_day.validation
                                ? " offset-2 offset-lg-0 offset-md-0 offset-sm-0"
                                : "")
                        }
                    >
                        {this.state.current_day !== null ? (
                            <FormControlLabel
                                label={this.state.dayValidated ? "Jour validé" : "Valider jour"}
                                classes={{ label: "white-text" }}
                                id="validation_button"
                                control={
                                    <Switch
                                        disabled={!this.state.dayValidated && !this.props.dayValidationAuthorized}
                                        onChange={this.props.validateDay}
                                        checked={this.state.dayValidated}
                                        value={"valide"}
                                        color="secondary"
                                    />
                                }
                            />
                        ) : null}
                    </div>
                    {this.props.current_day !== null && this.props.current_day.validation ? (
                        <div className="col-lg-1 col-md-1 col-sm-1 col-6 icon-btn-activity">
                            <Button onClick={this.props.resendValidateDay} className="white_button">
                                <svg
                                    viewBox="0 0 682.66669 682.66669"
                                    style={{
                                        flexShrink: 0,
                                        height: "24px",
                                        paddingTop: "5%",
                                        paddingBottom: "5%",
                                    }}
                                >
                                    <g transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)">
                                        <path
                                            d="M 0,0 -128,96 V 32 H -320.096 C -408.416,32 -480,-39.808 -480,-128 c 0,-26.816 6.592,-52.096 18.272,-74.272 l 52.32,39.232 c -4.256,10.848 -6.592,22.656 -6.592,35.04 0,52.896 42.944,96 95.904,96 H -128 v -64 z"
                                            fill="#ffffff"
                                            transform="translate(480,384)"
                                        />
                                        <path
                                            d="m 0,0 c 4.256,-10.88 6.592,-22.688 6.592,-35.072 0,-52.896 -42.945,-96 -95.905,-96 h -192.095 v 64 l -128,-96 128,-96 v 64 h 192.095 c 88.321,0 159.905,71.808 159.905,160 0,26.816 -6.592,52.096 -18.273,74.272 z"
                                            fill="#ffffff"
                                            transform="translate(441.4082,291.0718)"
                                        />
                                    </g>
                                </svg>
                            </Button>
                        </div>
                    ) : null}
                    <div
                        className={
                            "col-lg-1 col-md-1 col-sm-1 icon-btn-activity" +
                            (this.props.current_day !== null && this.props.current_day.validation
                                ? " col-6"
                                : " col-2 without-side-padding")
                        }
                    >
                        <Button
                            onClick={this.props.changeDisplayMode}
                            style={{ float: "right" }}
                            className="white_button"
                        >
                            {this.props.list_mode ? (
                                <Today style={{ float: "right", color: "#FFFFFF" }} />
                            ) : (
                                <ViewList style={{ float: "right", color: "#FFFFFF" }} />
                            )}
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}

// export default OptionChoicesActivity;

const mapStateToProps = (state) => {
    return {
        activeUser: state.activeUser,
        current_day: state.current_day,
        dayValidationAuthorized: state.dayValidationAuthorized,
        gpsStopped: state.gpsInformations.gpsStopped,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        loadActiveUser: () => dispatch(loadActiveUser()),
        // validateDay: (day) => dispatch(validateDay(day)),
        validateDaySend: (day, imputations) => dispatch(validateDaySendData(day, imputations)),
        dispatchWarning: (title, message, time) => dispatch(dispatchWarning(title, message, time)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(OptionChoicesActivity);
